import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { modifyAddress } from "../../store/actions/customers";
import { withRouter } from "react-router";
import WaitListDrawer from "../Branches/WaitList";
import DialogTemplate from "./DialogTemplate";
import DineSuperbDrawer from "./DineSuperbDrawer";
import Addresses from "../CheckoutProcess/Confirmation/Addresses";
import { remove_from_cart } from "../../store/actions";
import { getSavedAddresses } from "../../Helpers/orderPass";

class index extends Component {
  constructor(props) {
    super(props);
    this.scrollableDiv = React.createRef();
  }

  state = {
    drawerOpen: false,

    //drawer props
    dialogOpen: false,
    onClose: null,
    onOk: null,
    title: null,
    body: null,

    dineSuperbDrawerOpen: false,

    addressesDrawerOpen: false,
  };

  getSavedAddresses = () =>
    getSavedAddresses(
      { user: this.props.auth.user, addresses: this.props.auth.addresses },
      this.props.orderPassAddresses,
      this.props.settings,
    );

  isThereASavedDeliveryAddress = () => {
    const { address } = this.props;
    if (!address) return false;

    if (
      (!address.country && address.country !== 0) ||
      (!address.area && address.area !== 0) ||
      !address.block ||
      !address.street ||
      !address.building
    )
      return false;
    return true;
  };
  isThereASavedPickupArea = () => {
    const { address } = this.props;
    if (!address) return false;

    if (address.pickupArea !== undefined && address.pickupArea !== null)
      return true;
    return false;
  };
  findSavedBranchName = () => {
    const { address, branches, language } = this.props;
    let selectedBranch = branches.find(
      (branch) => branch.id == address.pickupArea
    );
    if (selectedBranch) {
      return language == "english"
        ? selectedBranch.name
        : selectedBranch.ar_name;
    }
    return false;
  };
  closeDialog = () => {
    this.setState({
      dialogOpen: false,
      onClose: null,
      onOk: null,
      title: null,
      body: null,
    });
  };

  printDeliveryAddress = () => {
    const { address, areas, language, countries } = this.props;

    if (!address) return false;
    if (address.area === undefined || address.area === null) return false;
    if (address.country === undefined || address.country === null) return false;

    let selectedArea = areas.find((area) => area.id == address.area);
    let selectedCountry = countries.find(
      (country) => country.id == address.country
    );
    if (!selectedArea || !selectedCountry) return false;
    const isQatar = selectedCountry.name == "Qatar";
    const isBahrain = selectedCountry.name == "Bahrain";
    let addressString =
      language == "english"
        ? `${isQatar ? "District: " : "Area: "}${selectedArea.name}`
        : `${isQatar ? "محافظة: " : "منطقة: "}${selectedArea.ar_name}`;
    addressString = addressString.concat(
      `;${
        language == "english"
          ? isQatar
            ? "Zone: "
            : "Block: "
          : isQatar
          ? "المنطقة: "
          : isBahrain
          ? "المجمع: "
          : "القطعة: "
      }${address.block}`
    );
    addressString = addressString.concat(
      `;${language == "english" ? "Street: " : "شارع: "}${address.street}`
    );
    addressString = addressString.concat(
      `;${language == "english" ? "Building: " : "مبنى: "}${address.building}`
    );
    if (address.avenue)
      addressString = addressString.concat(
        `;${language == "english" ? "Avenue: " : "جادة: "}${address.avenue}`
      );
    if (address.apartment)
      addressString = addressString.concat(
        `;${language == "english" ? "Apartment: " : "شقة: "}${
          address.apartment
        }`
      );
    if (address.paci)
      addressString = addressString.concat(
        `;${language == "english" ? "PACI: " : "الرقم الآلي: "}${address.paci}`
      );
    if (address.additional)
      addressString = addressString.concat(
        `;${language == "english" ? "Additional: " : "اضافي: "}${
          address.additional
        }`
      );

    return addressString;
  };
  handleDeliveryPickupYes = () => {
    const selectedType = this.props.address
      ? this.props.address.selectedDeliveryType
      : -1;
    const savedAddresses = this.getSavedAddresses();
    if (this.props.pickup_only) {
      let itemIndex = 0;
      this.props.cart.forEach((product, index) => {
        if (product.pickup_only) {
          this.props.remove_from_cart(index + itemIndex, product, false);
          --itemIndex;
        }
      });
      let itemIndexPromotion = 0;
      this.props.promo_items.forEach((product, index) => {
        if (product.pickup_only) {
          this.props.remove_from_cart(
            index + itemIndexPromotion,
            product,
            true
          );
          --itemIndexPromotion;
        }
      });
      if (selectedType !== 0) {
        if (savedAddresses.length > 0)
          this.setState({ addressesDrawerOpen: true });
        else
          this.props.history.push("/select/branch", {
            type: 0,
          });
      }
    }
    if (this.props.delivery_only) {
      let itemIndex = 0;
      this.props.cart.forEach((product, index) => {
        if (product.delivery_only) {
          this.props.remove_from_cart(index + itemIndex, product, false);
          --itemIndex;
        }
      });
      let itemIndexPromotion = 0;
      this.props.promo_items.forEach((product, index) => {
        if (product.delivery_only) {
          this.props.remove_from_cart(
            index + itemIndexPromotion,
            product,
            true
          );
          --itemIndexPromotion;
        }
      });
      if (selectedType !== 1) {
        this.props.history.push("/select/branch", {
          type: 1,
        });
      }
    }
  };

  render() {
    const {
      language,
      settings,
      branches,
      pickup_only,
      customTexts,
      delivery_only,
    } = this.props;
    const {
      drawerOpen,
      dialogOpen,
      onClose,
      onOk,
      title,
      body,
      dineSuperbDrawerOpen,
      addressesDrawerOpen,
    } = this.state;
    const buttonStyle = {
      lineHeight: 3,
      width: 80,
      maxHeight: 40,
      textTransform: "none",
      fontWeight: "bold",
      boxShadow: "none",
      borderRadius: 3,
      padding: 0,
    };

    const selectedType = this.props.address
      ? this.props.address.selectedDeliveryType
      : -1;
    const savedAddresses = this.getSavedAddresses();

    const waitLists =
      branches.map(({ waiting_lists }) => waiting_lists).flat(1) || [];

    const showDelivery =
      (settings.enable_delivery || settings.enable_delivery_select) &&
      !settings.is_menu;

    const showPickup =
      (settings.enable_pickup || settings.enable_pickup_select) &&
      !settings.is_menu;

    const showWaitLists =
      settings.show_waiting_lists && settings.enable_waiting_lists;

    const showBookingsLink =
      settings.enable_dinesuperb &&
      (superbBranches?.length > 0 || hasDineSuperbSetting);

    const widthOfText =
      language == "english"
        ? customTexts.delivery.length > 12 ||
          customTexts.pickup > 12 ||
          (showBookingsLink ? customTexts.dinesuperb_button_ar > 12 : false)
          ? "150px"
          : "80px"
        : customTexts.delivery_ar.length > 12 ||
          customTexts.pickup_ar > 12 ||
          (showBookingsLink ? customTexts.dinesuperb_button_ar > 12 : false)
        ? "150px"
        : "80px";

    const superbBranches = branches.filter(
      (branch) =>
        !!(branch.link_dinesuperb || "").trim() &&
        (branch.link_dinesuperb.includes("dinesuperb.com") ||
          branch.link_dinesuperb.includes("eatapp.co"))
    );
    const hasDineSuperbSetting =
      !!(settings.link_dinesuperb || "").trim() &&
      (settings.link_dinesuperb.includes("dinesuperb.com") ||
        settings.link_dinesuperb.includes("eatapp.co"));
    //  showBookingsLink =
    //   settings.enable_dinesuperb &&
    //   (superbBranches.length > 0 || hasDineSuperbSetting);

    if (
      !showWaitLists &&
      !(settings.enable_delivery || settings.enable_delivery_select) &&
      !showPickup &&
      !showBookingsLink
    ) {
      return null;
    }

    const showArrows =
      [showDelivery, showPickup, showBookingsLink, showWaitLists].filter(
        (condition) => !!condition
      ).length >= 4;
    return (
      <>
        <DialogTemplate
          open={dialogOpen}
          onClose={onClose}
          title={title}
          body={body}
          onOk={onOk}
          language={language}
        />
        {drawerOpen && (
          <WaitListDrawer
            drawerOpen={drawerOpen}
            toggleDrawer={() => this.setState({ drawerOpen: false })}
            waiting_lists={waitLists}
          />
        )}
        {dineSuperbDrawerOpen && (
          <DineSuperbDrawer
            drawerOpen={dineSuperbDrawerOpen}
            onClose={() => this.setState({ dineSuperbDrawerOpen: false })}
            dineSuperbBranches={superbBranches}
          />
        )}
        {addressesDrawerOpen && (
          <Addresses
            open={true}
            onClose={() => this.setState({ addressesDrawerOpen: false })}
            comingFrom="serviceTypeSelect"
          />
        )}
        <div
          className="row m-0 w-100"
          style={{ borderTop: "1px #dee2e6 solid" }}
        >
          {showArrows && (
            <div className="col-1 p-0">
              <div
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  height: "100%",
                  borderBottom: "1px solid #dee2e6",
                }}
                onClick={() => {
                  this.scrollableDiv.current.scrollLeft -= 1000;
                }}
              >
                <ArrowForwardIosIcon
                  style={{
                    position: "relative",
                    top: "33%",
                    transform: "scaleX(-1)",
                  }}
                  fontSize={"small"}
                />
              </div>
            </div>
          )}
          <div className={showArrows ? "col-10" : "col-12"}>
            <div className="scrollable-div">
              <div
                className="row border-bottom bg-white disable-scroll-bar"
                style={{
                  minHeight: 65,
                  whiteSpace: "no-wrap",
                  direction: language == "english" ? "ltr" : "rtl",
                }}
                ref={this.scrollableDiv}
              >
                {showDelivery ? (
                  <div
                    className={"bg-white m-auto col-4"}
                    style={{ maxWidth: widthOfText == "80px" ? "" : "none" }}
                  >
                    <Button
                      color="primary"
                      variant={selectedType == 0 ? "contained" : "none"}
                      style={{
                        ...buttonStyle,
                        border:
                          selectedType !== 0 ? "1px solid #666666" : "none",
                        color: selectedType !== 0 && "#666666",
                        width: widthOfText,
                      }}
                      onClick={() => {
                        if (pickup_only) {
                          this.setState({
                            dialogOpen: true,
                            onClose: () => this.setState({ dialogOpen: false }),
                            onOk: () => {
                              this.handleDeliveryPickupYes();
                              this.setState({ dialogOpen: false });
                            },
                            title: language === "english" ? "Warning" : "تحذير",
                            body:
                              language === "english"
                                ? "Your cart contains items that are for pickup only. Do you wish to clear your cart from pickup only items and start a delivery order?"
                                : "تحتوي عربة التسوق الخاصة بك على منتجات اللإستلام ففط. هل تريد مسح منتجات اللإستلام ففط من عربة التسوق الخاصة بك وبدء طلب توصيل؟",
                          });
                        } else if (!this.props.auth.user) {
                          if (selectedType != 0) {
                            if (savedAddresses.length > 0)
                              this.setState({ addressesDrawerOpen: true });
                            else
                              this.props.history.push("/select/branch", {
                                type: 0,
                              });
                          }
                        } else {
                          if (savedAddresses.length > 0)
                            this.setState({ addressesDrawerOpen: true });
                          else
                            this.props.history.push("/select/branch", {
                              type: 0,
                            });
                        }
                      }}
                    >
                      {language == "english"
                        ? customTexts.delivery
                        : customTexts.delivery_ar}
                    </Button>
                  </div>
                ) : null}
                {showPickup ? (
                  <div
                    className={"bg-white m-auto col-4"}
                    style={{ maxWidth: widthOfText == "80px" ? "" : "none" }}
                  >
                    <Button
                      color="primary"
                      variant={selectedType == 1 ? "contained" : "none"}
                      style={{
                        ...buttonStyle,
                        border:
                          selectedType !== 1 ? "1px solid #666666" : "none",
                        color: selectedType !== 1 && "#666666",
                        width: widthOfText,
                      }}
                      onClick={() => {
                        if (delivery_only) {
                          this.setState({
                            dialogOpen: true,
                            onClose: () => this.setState({ dialogOpen: false }),
                            onOk: () => {
                              this.handleDeliveryPickupYes();
                              this.setState({ dialogOpen: false });
                            },
                            title: language === "english" ? "Warning" : "تحذير",
                            body:
                              language === "english"
                                ? "Your cart contains items that are for delivery only. Do you wish to clear your cart from delivery only items and start a pickup order?"
                                : "تحتوي عربة التسوق الخاصة بك على منتجات التوصيل ففط. هل تريد مسح منتجات التوصيل ففط من عربة التسوق الخاصة بك وبدء طلب استلام؟",
                          });
                        } else if (selectedType != 1) {
                          this.props.history.push("/select/branch", {
                            type: 1,
                          });
                        }
                      }}
                    >
                      {language == "english"
                        ? customTexts.pickup
                        : customTexts.pickup_ar}
                    </Button>
                  </div>
                ) : null}

                {showWaitLists && (
                  <div
                    className={"bg-white m-auto col-4"}
                    style={{ maxWidth: widthOfText == "80px" ? "" : "none" }}
                  >
                    <Button
                      color="primary"
                      variant="none"
                      style={{
                        ...buttonStyle,
                        border: "1px solid #666666",
                        color: "#666666",
                        width: widthOfText,
                      }}
                      onClick={() => {
                        if (waitLists.length <= 1) {
                          this.props.history.push("/waitlist", {
                            waiting_list: waitLists.length
                              ? waitLists[0]
                              : null,
                          });
                        } else {
                          this.setState({ drawerOpen: true });
                        }
                      }}
                    >
                      {language == "english" ? "Waitlist" : "قائمة الانتظار"}
                    </Button>
                  </div>
                )}

                {showBookingsLink && (
                  <div
                    className={"bg-white m-auto col-4"}
                    style={{ maxWidth: widthOfText == "80px" ? "" : "none" }}
                  >
                    <Button
                      color="primary"
                      variant="none"
                      style={{
                        ...buttonStyle,
                        border: "1px solid #666666",
                        color: "#666666",
                        width: widthOfText,
                      }}
                      onClick={() => {
                        if (hasDineSuperbSetting) {
                          let win = window.open(
                            settings.link_dinesuperb,
                            "_blank"
                          );
                          win.focus();
                          return;
                        }
                        if (superbBranches.length == 1) {
                          let win = window.open(
                            superbBranches[0].link_dinesuperb,
                            "_blank"
                          );
                          win.focus();
                        } else this.setState({ dineSuperbDrawerOpen: true });
                      }}
                    >
                      {language == "english"
                        ? customTexts.dinesuperb_button
                        : customTexts.dinesuperb_button_ar}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
          {showArrows && (
            <div className="col-1 p-0 ">
              <div
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  height: "100%",
                  borderBottom: "1px solid #dee2e6",
                }}
                onClick={() => {
                  this.scrollableDiv.current.scrollLeft += 1000;
                }}
              >
                <ArrowForwardIosIcon
                  style={{ position: "relative", top: "33%" }}
                  fontSize={"small"}
                />
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    address: state.customers.address,
    settings: state.store.store.settings,
    branches: state.store.store.branches,
    areas: state.store.store.areas,
    countries: state.store.store.countries,
    pickup_only: state.cart.pickup_only_items,
    delivery_only: state.cart.delivery_only_items,
    customTexts: state.store.store.settings.custom_texts,
    auth: state.auth,
    orderPassAddresses: state.customers.orderPassAddresses || [],
    cart: state.cart.cart,
    promo_items: state.cart.promo_items,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    modifyAddress: (obj) => dispatch(modifyAddress(obj)),
    remove_from_cart: (product_index, product, PromoItem) =>
      dispatch(remove_from_cart(product_index, product, PromoItem)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index));
